import axiosInstance from "../api";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import {
  GET_FILTERD_MERGER,
  GET_MERGER,
  GET_MERGER_BY_ID,
  GET_MERGER_MINE,
  GET_MERGERS_ORDER_DETAILS,
  GET_MINE_MERGERS_ORDER_DETAILS,
} from "../constants";
import { getPostCounts } from "../posts/action";

export const getMergerList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`mergers`);
    if (response?.data?.status) {
      dispatch({ type: GET_MERGER, getmergerslist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const interestedinMerger = (id, navigate) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `mergers?id=${id}&interested=1`
    );
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      return response?.data
    }
    else {
      urtoast(response?.data?.response?.message, 2);
      //  if (response?.data?.response?.extra == 3) {
      //   const laung = localStorage.getItem("laung");
      //   if (navigate) {
      //     navigate(`/${laung}/account/upgrademembership`)
      //   }
      // }
      return response?.data
    }
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const FilterMergerListings = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("mergers", data);
    if (response?.data?.status) {
      dispatch({ type: GET_FILTERD_MERGER, getfilterdmergers: response.data });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const getMineMergerList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`mergers?is_mine=1`);
    if (response?.data?.status) {
      dispatch({
        type: GET_MERGER_MINE,
        getminemergerslist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addMerger = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("mergers/create", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getMineMergerList())
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateMerger = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("mergers/update", data);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getMineMergerList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const getMergerById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`mergers?id=${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_MERGER_BY_ID,
        getmergersbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addtowishinMergerbyid = (id, handllGetAllData) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`mergers?id=${id}&wishlist=1`);
    if (response?.data?.status) {
      dispatch(getMergerById(id));
      handllGetAllData()
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const deleteMerger = (id, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`mergers/delete?id=${id}`);
    if (response?.data?.status) {
      setLoading(false);
      dispatch(getPostCounts(6));
      dispatch(getMineMergerList());
      urtoast(response?.data?.response?.message, 1);
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const getMineMergersOrderList = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `mergers?is_mine=1&status=${status}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_MINE_MERGERS_ORDER_DETAILS,
        minemergersorderlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
export const getMergersOrderList = (status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`mergers?status=${status}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_MERGERS_ORDER_DETAILS,
        mergersorderlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
